import type { FC, ReactNode } from 'react';
import { Link } from 'react-router';
import { Container } from 'src/components/layout/container';
import {
  HeaderPrimaryBackground,
  HeaderPrimaryCenter,
} from 'src/components/layout/header/primary-nav';
import {
  HeaderSecondaryBackground,
  HeaderSecondaryCenter,
} from 'src/components/layout/header/secondary-nav';
import { Layout, LayoutHeader, LayoutMain } from 'src/components/layout/layout';
import { Logo } from 'src/components/media-and-icons/logo';

export const SimpleHeader: FC = () => {
  let isBrowser = true;
  try {
    // PRISMA_CONFIG isn't available on server-side render
    void PRISMA_CONFIG;
  } catch {
    isBrowser = false;
  }
  return (
    <>
      <HeaderPrimaryBackground>
        <Container>
          <HeaderPrimaryCenter>
            <div className="grid grid-flow-col items-center">
              {isBrowser ? (
                <Link to="/">
                  <Logo />
                </Link>
              ) : (
                <a href="https://app.prisma-capacity.eu">
                  <Logo />
                </a>
              )}
            </div>
          </HeaderPrimaryCenter>
        </Container>
      </HeaderPrimaryBackground>
      <HeaderSecondaryBackground>
        <Container>
          <HeaderSecondaryCenter></HeaderSecondaryCenter>
        </Container>
      </HeaderSecondaryBackground>
    </>
  );
};

export const SimplePageLayout: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Layout>
      <LayoutHeader>
        <SimpleHeader />
      </LayoutHeader>
      <LayoutMain>
        <Container>{children}</Container>
      </LayoutMain>
    </Layout>
  );
};
